import {
  urlLogin,
  urlCambiarContrasenia,
  urlRecuperarContrasenia,
  urlVerificarToken,
  urlListarCompras,
  urlConsultarUsrOkta,
  urlRedireccionLogin,
} from "../../constants/urls";
import { urlLoginPost } from "../../constants/urls";
import { createAction } from "redux-actions";
import moment from "moment";
import { stringABase64 } from "../../utils/Encriptar";

export const LOGIN_HAS_ERRORED = "LOGIN_HAS_ERRORED";
export const LOGIN_IS_LOADING = "LOGIN_IS_LOADING";
export const CAMBIAR_CONTRASENIA_HAS_ERRORED =
  "CAMBIAR_CONTRASENIA_HAS_ERRORED";
export const CAMBIAR_CONTRASENIA_IS_LOADING = "CAMBIAR_CONTRASENIA_IS_LOADING";

export const SOLICITAR_CONTRASENIA_HAS_ERRORED =
  "SOLICITAR_CONTRASENIA_HAS_ERRORED";
export const SOLICITAR_CONTRASENIA_IS_LOADING =
  "SOLICITAR_CONTRASENIA_IS_LOADING";

export const VERIFICAR_TOKEN_HAS_ERRORED = "VERIFICAR_TOKEN_HAS_ERRORED";
export const VERIFICAR_TOKEN_IS_LOADING = "VERIFICAR_TOKEN_IS_LOADING";
export const RECUPERAR_CONTRASENIA_OK = "RECUPERAR_CONTRASENIA_OK";

export const USER_IS_LOGGED_IN = "USER_IS_LOGGED_IN";
export const CAMBIAR_CONTRASENIA_OK = "CAMBIAR_CONTRASENIA_OK";
export const SET_MSG_ERROR_CAMBIO_CONTRASENA =
  "SET_MSG_ERROR_CAMBIO_CONTRASENA";
export const SET_DATA_USUARIO = "SET_DATA_USUARIO";

export const ENVIAR_CORREO = "ENVIAR_CORREO";
export const LIMPIAR_LOGIN = "LIMPIAR_LOGIN";
export const LIMPIAR_CAMBIAR_CONTRASENIA = "LIMPIAR_CAMBIAR_CONTRASENIA";
export const LIMPIAR_SOLICITAR_CONTRASENIA = "LIMPIAR_SOLICITAR_CONTRASENIA";
export const LIMPIAR_TOKEN = "LIMPIAR_TOKEN";
export const SET_COUNT_CARRITO = "SET_COUNT_CARRITO";
export const SET_DATA_LEEDS = "SET_DATA_LEEDS";

export const LISTA_COMPRAS_HAS_ERRORED = "LISTA_COMPRAS_HAS_ERRORED";
export const SET_DATA_LISTA_COMPRAS = "SET_DATA_LISTA_COMPRAS";
export const SET_DATA_LISTA_RAMOS = "SET_DATA_LISTA_RAMOS";
export const LISTA_COMPRAS_LOADING = "LISTA_COMPRAS_LOADING";
export const LIMPIAR_DATOS_LISTA_COMPRAS = "LIMPIAR_DATOS_LISTA_COMPRAS";

const loginError = createAction(LOGIN_HAS_ERRORED);
const loginIsLoading = createAction(LOGIN_IS_LOADING);
const cambiarContraseniaError = createAction(CAMBIAR_CONTRASENIA_HAS_ERRORED);
const cambiarContraseniaIsLoading = createAction(
  CAMBIAR_CONTRASENIA_IS_LOADING
);
const verificarTokenError = createAction(VERIFICAR_TOKEN_HAS_ERRORED);
const verificarTokenIsLoading = createAction(VERIFICAR_TOKEN_IS_LOADING);
const solicitarContraseniaError = createAction(
  SOLICITAR_CONTRASENIA_HAS_ERRORED
);
const solicitarContraseniaIsLoading = createAction(
  SOLICITAR_CONTRASENIA_IS_LOADING
);

export const limpiarCambioContrasenia = createAction(
  LIMPIAR_CAMBIAR_CONTRASENIA
);

export const limpiarVerificarToken = createAction(LIMPIAR_TOKEN);

export const limpiarSolicitarContrasenia = createAction(
  LIMPIAR_SOLICITAR_CONTRASENIA
);

export const limpiarLogin = createAction(LIMPIAR_LOGIN);
export const setContraseniaOK = createAction(CAMBIAR_CONTRASENIA_OK);
export const setMsgCambiarContrasena = createAction(
  SET_MSG_ERROR_CAMBIO_CONTRASENA
);
export const recuperarContraseniaOK = createAction(RECUPERAR_CONTRASENIA_OK);
export const enviarCorreo = createAction(ENVIAR_CORREO);

export const dataUsuario = createAction(SET_DATA_USUARIO);
export const setDataLeeds = createAction(SET_DATA_LEEDS);
export const listaComprasHasErrored = createAction(LISTA_COMPRAS_HAS_ERRORED);
export const listaComprasIsLoading = createAction(LISTA_COMPRAS_LOADING);
export const setListaCompras = createAction(SET_DATA_LISTA_COMPRAS);
export const setListaRamos = createAction(SET_DATA_LISTA_RAMOS);
export const limpiarListaCompras = createAction(LIMPIAR_DATOS_LISTA_COMPRAS);


export function userIsLoggedIn(bool) {
  return {
    type: USER_IS_LOGGED_IN,
    userIsLoggedIn: bool,
  };
}
export function countCarrito(val) {
  return {
    type: SET_COUNT_CARRITO,
    countCarrito: val,
  };
}

// Actions para  OKTA
export const setAutenticarOkta = createAction('SET_AUTENTICAR_OKTA');
export const setOktaHasError = createAction('SET_OKTA_HAS_ERROR');
export const setOktaIsLoading = createAction('SET_OKTA_IS_LOADING');



// Objeto data usuario
const dataUsuario1 = {
  correo: "",
  cedula: "",
  nombres: "",
  apellidos: "",
  sucursal: "",
  sucursalCodCore: "",
  errorDescripcion: "",
  userIsLoggedIn: false,
  cliCodigoCore: "",
  disclaimerVer: false,
  disclaimerFecha: "",
  disclaimerUrl: "",
};


// ------------------ INICIAN Funciones que utilizan Actions ------------------

export const loginFetch = (body) => async (dispatch) => {
  dispatch(loginIsLoading());
  await fetch(urlLoginPost,{
    method: 'POST',
    body: JSON.stringify({
        ...body
    })
  })
    .then((response) => response.json())
    .then((data) => {
      //data = desencriptarTramaAES(data.Data, data.key, data.iv);
      const transaccion = data.transaccion;
      if (transaccion) {
        let nombres1 = data.cliNombre1 + " " + data.cliNombre2;
        let apellidos1 = data.cliApellido1 + " " + data.cliApellido2;
        let disFechaAux = "";
        if (
          data.disclaimerFecha !== null &&
          data.disclaimerFecha !== "" &&
          data.disclaimerFecha !== undefined
        ) {
          disFechaAux = data.disclaimerFecha;
        }
        if (!data.cliNombre2) nombres1 = data.cliNombre1;

        if (!data.cliApellido2) apellidos1 = data.cliApellido1;

        const dataUsuario2 = {
          ...dataUsuario1,
          correo: data.cliEmail,
          cedula: data.cliIdentificacion,
          nombres: nombres1,
          apellidos: apellidos1,
          sucursal: data.cliSucursal,
          sucursalCodCore: data.sucCodigoCore,
          errorDescripcion: data.errorDescripcion,
          userIsLoggedIn: true,
          cliCodigoCore: data.cliCodigoCore,
          disclaimerVer: data.disclaimerVer,
          disclaimerFecha: disFechaAux,
          disclaimerUrl: data.disclaimerUrl,
          usu_tipo_usuario: data.cliTipo,
          brokerRUC: data.brokerRUC ? data.brokerRUC : "",
          brokerNombre: data.brokerNombre ? data.brokerNombre : "",
          brokerCodigo: data.brokerCodigo ? data.brokerCodigo : "",
          fechaUltimoAcceso: data.fechaUltimoAcceso
            ? data.fechaUltimoAcceso
            : undefined,
            fromMobile:false,
          clienteFinal:false
        };
        dispatch(dataUsuario(dataUsuario2));
      } else {
        const dataUsuario1 = {
          ...dataUsuario,
          errorDescripcion: data.errorDescripcion,
        };
        dispatch(dataUsuario(dataUsuario1));
        dispatch(loginError());
      }
    })

    .catch(() => {
      const dataUsuario1 = {
        ...dataUsuario,
        errorDescripcion: "Error general",
      };
      dispatch(dataUsuario(dataUsuario1));
      dispatch(loginError());
    });
};

export const solicitarContraseniaFetch = (body, history) => async (
  dispatch
) => {
  console.log("cambiar", urlRecuperarContrasenia + body);
  dispatch(solicitarContraseniaIsLoading());
  await fetch(urlRecuperarContrasenia + body)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);

      //data = desencriptarTramaAES(data.Data, data.key, data.iv);
      const transaccion = data.transaccion;
      if (transaccion) {
        dispatch(enviarCorreo(true));
      } else {
        console.log("entre a else ", transaccion);
        dispatch(solicitarContraseniaError());
      }
    })

    .catch(() => {
      dispatch(solicitarContraseniaError());
    });
};

export const cambiarContraseniaFetch = (body, history) => async (dispatch) => {
  //console.log("cambiar", urlCambiarContrasenia + body);
  dispatch(cambiarContraseniaIsLoading());
  await fetch(urlCambiarContrasenia + body)
    .then((response) => response.json())
    .then((data) => {
      //console.log(data);

      //data = desencriptarTramaAES(data.Data, data.key, data.iv);
      const transaccion = data.transaccion;
      if (transaccion) {
        dispatch(setContraseniaOK(true));
      } else {
        dispatch(cambiarContraseniaError());
        if (data.errorDescripcion) {
          dispatch(setMsgCambiarContrasena(data.errorDescripcion));
        }
      }
    })

    .catch(() => {
      dispatch(cambiarContraseniaError());
    });
};

export const verificarTokenFetch = (body, history) => async (dispatch) => {
  //console.log("cambiar", urlVerificarToken + body);
  dispatch(verificarTokenIsLoading());
  await fetch(urlVerificarToken + body)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);

      //data = desencriptarTramaAES(data.Data, data.key, data.iv);
      const transaccion = data.transaccion;
      if (transaccion) {
        dispatch(recuperarContraseniaOK(true));
      } else {
        dispatch(verificarTokenError());
      }
    })

    .catch(() => {
      dispatch(verificarTokenError());
    });
};

export const loginClienteFinalFetch = (data) => async (dispatch) => {
  console.log('loginClienteFinalFetch',data);
  let nombres1 = data.cliNombre1 + " " + data.cliNombre2;
  let apellidos1 = data.cliApellido1 + " " + data.cliApellido2;
  let disFechaAux = "";
  if (
    data.disclaimerFecha !== null &&
    data.disclaimerFecha !== "" &&
    data.disclaimerFecha !== undefined
  ) {
    disFechaAux = data.disclaimerFecha;
  }
  if (!data.cliNombre2) nombres1 = data.cliNombre1;

  if (!data.cliApellido2) apellidos1 = data.cliApellido1;

  const dataUsuario2 = {
    ...dataUsuario1,
    correo: data.cliEmail,
    cedula: data.cliIdentificacion,
    nombres: nombres1,
    apellidos: apellidos1,
    sucursal: data.cliSucursal,
    sucursalCodCore: data.sucCodigoCore,
    errorDescripcion: data.errorDescripcion,
    userIsLoggedIn: true,
    cliCodigoCore: data.carDatosAsesor.cliCodigoCore,
    disclaimerVer: data.disclaimerVer,
    disclaimerFecha: disFechaAux,
    disclaimerUrl: data.disclaimerUrl,
    usu_tipo_usuario: data.cliTipo,
    brokerRUC: data.carDatosAsesor.brokerRUC ? data.carDatosAsesor.brokerRUC : "",
    brokerNombre: data.carDatosAsesor.brokerNombre ? data.carDatosAsesor.brokerNombre : "",
    brokerCodigo: data.carDatosAsesor.brokerCodigo ? data.carDatosAsesor.brokerCodigo : "",
    fechaUltimoAcceso:moment(new Date()).format("DD-MM-YYYY HH:mm:ss"),
    fromMobile:true,
    tipoCotizador:data.tipoCotizador,
    clienteFinal:true
  };
  console.log('dataUsuario2',dataUsuario2);
  dispatch(dataUsuario(dataUsuario2));
};
export const FetchListadoCompras = (param, ambiente) => async (dispatch) => {
  var url = `${urlListarCompras}${param}&ambiente=${ambiente}`;
  //console.log("AAAAAAAAAAAAAAA", url)
  dispatch(listaComprasIsLoading());
  await fetch(url)
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion) {
        if (data.arraycompras !== undefined) {

          console.log('Compras-Ventas 2',data)
          dispatch(limpiarListaCompras());
          dispatch(setListaCompras(data.arraycompras));
          dispatch(setListaRamos(data.ramosfiltro));
        } else {
          dispatch(limpiarListaCompras());
        }
      } else {
        dispatch(listaComprasHasErrored());
      }
    })
    .catch((response) => {
      dispatch(listaComprasHasErrored());
    });
};

/*Mobile */
export const loginMobileFetch = (data) => async (dispatch) => {
  console.log('loginMobileFetch',data);
  let nombres1 = data.cliNombre1 + " " + data.cliNombre2;
  let apellidos1 = data.cliApellido1 + " " + data.cliApellido2;
  let disFechaAux = "";
  if (
    data.disclaimerFecha !== null &&
    data.disclaimerFecha !== "" &&
    data.disclaimerFecha !== undefined
  ) {
    disFechaAux = data.disclaimerFecha;
  }
  if (!data.cliNombre2) nombres1 = data.cliNombre1;

  if (!data.cliApellido2) apellidos1 = data.cliApellido1;

  const dataUsuario2 = {
    ...dataUsuario1,
    correo: data.cliEmail,
    cedula: data.cliIdentificacion,
    nombres: nombres1,
    apellidos: apellidos1,
    sucursal: data.cliSucursal,
    sucursalCodCore: data.sucCodigoCore,
    errorDescripcion: data.errorDescripcion,
    userIsLoggedIn: true,
    cliCodigoCore: data.cliCodigoCore,
    disclaimerVer: data.disclaimerVer,
    disclaimerFecha: disFechaAux,
    disclaimerUrl: data.disclaimerUrl,
    usu_tipo_usuario: data.cliTipo,
    brokerRUC: data.brokerRUC ? data.brokerRUC : "",
    brokerNombre: data.brokerNombre ? data.brokerNombre : "",
    brokerCodigo: data.brokerCodigo ? data.brokerCodigo : "",
    fechaUltimoAcceso: data.disclaimerFecha
      ? moment(new Date()).format("DD-MM-YYYY HH:mm:ss")
      : undefined,
    fromMobile:true,
    tipoCotizador:data.tipoCotizador,
    clienteFinal:false,
  };
  console.log('dataUsuario2',dataUsuario2);
  dispatch(dataUsuario(dataUsuario2));
};


// -------------------- Validar usuarios OKTA --------------------
export const validarUsuariosOkta = ({email}) => async (dispatch) => {
  // loading
  dispatch(setOktaIsLoading());
  // llamar servicio
  await fetch(urlConsultarUsrOkta +stringABase64(email))
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      //data = desencriptarTramaAES(data.Data, data.key, data.iv);
      const transaccion = data.transaccion;
      if (transaccion) {
        dispatch(setAutenticarOkta(data.autenticarOkta));
      } else {
        dispatch(setOktaHasError());
      }
    })
    // manejar excepciones
    .catch(() => {
      dispatch(setOktaHasError());
    });
};
// -------------------- Finaliza Validar usuarios OKTA --------------------



// ------------------ FINALIZAN Funciones que utilizan Actions ------------------